import * as React from 'react';
import {useEffect, useState} from "react";
import {addEsignTemplate, getEsignProfiles, getTemplates} from "../../api";
import Table from "../Table";
import Modal from "../Modal";
import {EsignProfile, Template} from "../../types";


const ManageTemplates: React.FunctionComponent = () => {

    let esignEndpoint = (window.location.protocol + '//' + window.location.hostname);
    if (window.location.hostname === "34.201.190.181") {
        esignEndpoint = "http://34.201.190.181:3005";
    }
    if (window.location.hostname === "localhost") {
        esignEndpoint = "http://localhost:2999";
    }

    if (window.location.hostname === "test.promises12data.com" || window.location.hostname === "promises12data.com") {
        esignEndpoint = "https://esign.promises12data.com";
    }

    const [templates, setTemplates] = useState<Template[]>([]);
    const [profile, setProfile] = useState<EsignProfile>();

    const [showAdd, setShowAdd] = useState(false);
    const [name, setName] = useState("");
    const [tag, setTag] = useState("form");
    const [file, setFile] = useState<File | undefined>(undefined);
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState("");

    const loadTemplates = (profileId: string) => {
        getTemplates(profileId)
            .then((t) => {
                setTemplates(t);
            });
    };

    useEffect(() => {
        getEsignProfiles()
            .then((ps) => {
                setProfile(ps.filter((p) => p.name === "Promises12")[0]);
            })

    }, []);

    useEffect(() => {
        if (profile !== undefined) {
            loadTemplates(profile.uuid);
        }

    }, [profile]);

    const openAdd = () => {
        setName("");
        setTag("form");
        setFile(undefined);
        setMessage("");
        setShowAdd(true);
    };

    const onFileSelected = (selected?: File) => {
        setFile(selected);
        setMessage("");
        // Default the name to the file name (without extension) the first time a file is chosen,
        // but leave any name the user has already typed untouched.
        if (selected && name.trim() === "") {
            setName(selected.name.replace(/\.pdf$/i, ""));
        }
    };

    const doAdd = async () => {
        setMessage("");
        if (name.trim() === "") {
            setMessage("Please enter a name.");
            return;
        }
        if (!file) {
            setMessage("Please choose a PDF file.");
            return;
        }
        const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
        if (!isPdf) {
            setMessage("The file must be a PDF.");
            return;
        }
        setSubmitting(true);
        try {
            await addEsignTemplate(name.trim(), tag, file);
            setShowAdd(false);
            setName("");
            setFile(undefined);
            if (profile !== undefined) {
                loadTemplates(profile.uuid);
            }
        } catch (e) {
            console.log(e);
            setMessage("Failed to add document. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };


    return (<>
        <div className={"row"}>
            <div className={"col-lg-12 mb-3 "}>
                <h2>Document Templates</h2>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <button type={"button"} className={"btn btn-primary"} onClick={openAdd}>
                    Add Document
                </button>
            </div>
            <div className={"col-lg-6 mb-3 "}>
                <Table headers={["Name"]}
                       defaultPaginationSize={10}>
                    {
                        templates?.map((t) => (
                            <tr key={t.uuid}>
                                <td>
                                    <a rel="noopener noreferrer"
                                       href={esignEndpoint + "/designer/" + profile?.uuid + "/" + t.uuid}
                                       target={"_blank"}>
                                        {t.name}
                                    </a>
                                </td>
                                <td></td>
                            </tr>
                        ))
                    }

                </Table>
            </div>
        </div>

        <Modal show={showAdd}
               title={"Add Document"}
               cancelButtonText={"Cancel"}
               okButtonText={submitting ? "Adding..." : "Add"}
               disableOk={submitting}
               doCancel={() => setShowAdd(false)}
               doOk={doAdd}>
            <div className="form-group">
                <label htmlFor="inputName">Name</label>
                <input type="text" className="form-control" id="inputName"
                       value={name} onChange={(e) => setName(e.target.value)}/>
            </div>
            <div className="form-group">
                <label htmlFor="inputType">Type</label>
                <select id="inputType" className="form-control"
                        value={tag} onChange={(e) => setTag(e.target.value)}>
                    <option value="form">form</option>
                    <option value="note">note</option>
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="inputPdf">PDF File</label>
                <input type="file" accept="application/pdf,.pdf" className="form-control-file" id="inputPdf"
                       onChange={(e) => onFileSelected(e.target.files?.[0])}/>
            </div>
            {message &&
                <div className="alert alert-danger" role="alert">{message}</div>
            }
        </Modal>
    </>);
};

export default ManageTemplates;
